import { create } from "zustand";
import { persist } from "zustand/middleware";

const store = (set, get) => ({
  sidebarVisible: true,
  setSidebarVisible: (visible) => set((state) => ({ sidebarVisible: visible })),
});

export const useAppStore = create(persist(store, { name: "app-store" }));
